
import AppButton from "@/components/AppButton.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import OrderItem from "@/components/OrderItemNew.vue";
import Request from "@/ts/Request";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    HeaderColor,
    ModalCodigo,
    OrderItem,
    AppButton,
  },
})
export default class Survey extends Vue {
  surveys: any = [];
  surveyId = 0;
  questions: any = [];
  rating = 0;
  comment = "";
  selectedRateOptionId = 0;
  selectedGoodPoints: string[] = [];
  selectedBadPoints: string[] = [];
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.mostraModal,
  };
  orderData: any = {};
  modalMessage = "";
  modalCallback?: Function;
  showModal = false;
  loadedQuestions = false;

  get hasSelections(): boolean {
    return (
      this.selectedGoodPoints.length > 0 ||
      this.selectedBadPoints.length > 0 ||
      this.comment.trim().length > 0
    );
  }

  get ratingLabel(): string {
    if (this.rating >= 9) return "Excelente";
    if (this.rating >= 7) return "Bom";
    if (this.rating >= 5) return "Regular";
    if (this.rating >= 3) return "Ruim";
    if (this.rating > 0) return "Péssimo";
    return "";
  }

  mounted() {
    this.getOrderData();
    this.getUserSurveys();
  }

  async getUserSurveys() {
    this.loadedQuestions = false;
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
      };
      req.route = "getSurveys";
      req.callbackSuccess = async function (response: any) {
        if (!response.surveys.length) {
          self.surveyId = await self.createOrUpdateSurvey();
          if (self.surveyId) await self.getUserSurveys();
          return;
        }

        self.surveys = response.surveys[0];
        self.surveyId = self.surveys.id;
        self.getSurveyInfo();
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  async createOrUpdateSurvey() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        DESCRIPTION: "Avalie o pedido.",
        FINAL_DATE: "31/12/2099 23:59",
        INITIAL_DATE: "01/05/2025 00:00",
        NAME: "Avaliação do Pedido",
        STATUS: "A",
      };
      req.route = "createOrUpdateSurvey";

      const surveyId: any = await new Promise((resolve) => {
        req.callbackSuccess = (response: any) =>
          resolve(response.response.surveyId);
        req.callbackError = (error: any) => resolve(null);
        req.blockTouchEvents = false;
        req.send();
      });

      if (!surveyId) return null;

      const options: string[] = [
        "Sabor",
        "Ingredientes",
        "Embalagem",
        "Temperatura",
        "Aparência",
        "Quantidade",
        "Entrega",
      ];
      const questionConfigs: any[] = [
        {
          type: "rate",
          title: "Como foi a sua experiência?",
          description: "A sua opinião é muito importante para nós!",
          limit: 10,
          surveyId,
          numberOfStars: 10,
          options: [],
        },
        {
          type: "checkbox",
          title: "O que você gostou?",
          description: "O que você gostou?",
          limit: 10,
          surveyId,
          numberOfStars: "",
          options: options,
        },
        {
          type: "checkbox",
          title: "O que pode melhorar?",
          description: "O que pode melhorar?",
          limit: 10,
          surveyId,
          numberOfStars: "",
          options: options,
        },
        {
          type: "textarea",
          title: "Quer deixar algum comentário adicional?",
          description: "Quer deixar algum comentário adicional?",
          limit: 10,
          surveyId,
          numberOfStars: "",
          options: ["Comentário"],
        },
      ];

      await Promise.all(
        questionConfigs.map((q) => self.createOrUpdateQuestion(q))
      );

      return surveyId;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async createOrUpdateQuestion(question: any) {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        EVT_EVENT_ID: "",
        GEN_STRUCTURE_ID: "",
        QUESTION_ID: "",
        STATUS: "A",
        HAS_COMMENT: 0,
        LIMIT_QUANTITY: question.limit,
        NAME: question.title,
        NOTE: question.description,
        NUMBER_OF_STARS: question.numberOfStars,
        SURVEY_ID: question.surveyId,
        TYPE: question.type,
      };
      req.route = "createOrUpdateQuestion";

      const questionId: any = await new Promise((resolve) => {
        req.callbackSuccess = (response: any) =>
          resolve(response.response.questionId);
        req.callbackError = (error: any) => resolve(null);
        req.blockTouchEvents = false;
        req.send();
      });

      if (!questionId) return null;

      await Promise.all(
        question.options.map((opt: any) =>
          self.createOrUpdateAnswerOption(opt, questionId)
        )
      );

      return questionId;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  createOrUpdateAnswerOption(nameOption: string, questionId: number) {
    return new Promise((resolve) => {
      try {
        const req = new Request();
        req.body = {
          USER_ID: sessionStorage.getItem("USER_ID"),
          NRORG: sessionStorage.getItem("NRORG"),
          TOKEN: sessionStorage.getItem("TOKEN"),
          ANSWER_SURVEY_ID: "",
          STATUS: "A",
          NAME: nameOption,
          QUESTION_ID: questionId,
          TYPE: "",
        };
        req.route = "createOrUpdateAnswerOption";
        req.callbackSuccess = (response: any) =>
          resolve(response.response.answerSurveyId);
        req.callbackError = (error: any) => resolve(null);
        req.blockTouchEvents = false;
        req.send();
      } catch (e) {
        console.log(e);
        resolve(null);
      }
    });
  }

  getSurveyInfo() {
    const self = this;
    const req = new Request();
    req.body = {
      USER_ID: sessionStorage.getItem("USER_ID"),
      NRORG: sessionStorage.getItem("NRORG"),
      TOKEN: sessionStorage.getItem("TOKEN"),
      SURVEY_ID: this.surveys.id,
    };
    req.route = "getSurQuestion";
    req.callbackSuccess = (response: any) => {
      self.questions = response.surQuestionsData;

      const deliverTo = self.orderData.deliverTo;

      self.questions.forEach((question: any) => {
        if (question.type === "rate") {
          question.answers = question.answers.sort((a: any, b: any) => {
            return parseInt(a.answer) - parseInt(b.answer);
          });
        } else if (question.type === "checkbox") {
          question.answers = question.answers.map((answer: any) => {
            if (deliverTo !== "A" && answer.answer === "Entrega") return null;

            if (answer.answer === "Sabor") answer.icon = "utensils";
            else if (answer.answer === "Ingredientes") answer.icon = "wheat";
            else if (answer.answer === "Embalagem") answer.icon = "box-heart";
            else if (answer.answer === "Temperatura")
              answer.icon = "thermometer-half";
            else if (answer.answer === "Aparência") answer.icon = "laugh";
            else if (answer.answer === "Quantidade") answer.icon = "list-ol";
            else if (answer.answer === "Entrega") answer.icon = "clock";
            else answer.icon = "clock";

            return answer;
          });
        }
      });

      self.loadedQuestions = true;
    };
    req.callbackError = function (error: any) {
      console.log(error);
      self.loadedQuestions = false;
    };
    req.blockTouchEvents = false;
    req.send();
  }

  submitSurvey(): void {
    const questions: any[] = [];

    this.questions.forEach((question: any) => {
      if (question.type === "rate" && this.selectedRateOptionId) {
        questions.push({
          id: question.id,
          type: "rate",
          answer: this.selectedRateOptionId,
          comment: "",
        });
      } else if (
        question.type === "checkbox" &&
        this.selectedGoodPoints.length &&
        question.question === "O que você gostou?"
      ) {
        questions.push({
          id: question.id,
          type: "checkbox",
          answer: this.selectedGoodPoints || [],
          comment: "",
        });
      } else if (
        question.type === "checkbox" &&
        this.selectedBadPoints.length &&
        question.question === "O que pode melhorar?"
      ) {
        questions.push({
          id: question.id,
          type: "checkbox",
          answer: this.selectedBadPoints || [],
          comment: "",
        });
      } else if (question.type === "textarea" && this.comment) {
        questions.push({
          id: question.id,
          type: "textarea",
          answer: this.comment || "",
          comment: "",
        });
      }
    });

    const userAnswers = {
      surveyId: this.surveyId,
      questions: questions,
    };

    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        SURVEY_ID: userAnswers.surveyId,
        SURVEY_ANSWERS: userAnswers,
        ORDER_ID: this.orderData.orderId,
      };
      req.route = "submitAnswers";
      req.callbackSuccess = function () {
        self.$toast.success("Obrigado pela sua avaliação!");
        self.goBack();
      };
      req.callbackError = function () {
        self.$toast.success("Ocorreu um erro ao finalizar a avaliação.");
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  mostraModal() {
    this.showModal = true;
    this.modalMessage =
      "Sua avaliação não foi salva, caso saia agora, as alterações serão perdidas.";
    this.modalCallback = () => {
      this.goBack();
    };
  }

  selectedRate(starsSeletected: number, questionId: number) {
    this.rating = starsSeletected;
    this.selectedRateOptionId = questionId;
  }

  togglePoint(question: string, point: string): void {
    const type: "bad" | "good" =
      question === "O que pode melhorar?" ? "bad" : "good";
    const list =
      type === "good" ? this.selectedGoodPoints : this.selectedBadPoints;
    const index = list.indexOf(point);
    if (index === -1) list.push(point);
    else list.splice(index, 1);
  }

  goBack() {
    const cameFromConfirmCode = JSON.parse(
      sessionStorage.getItem("CAME_FROM_CONFIRM_CODE") || "false"
    );
    if (cameFromConfirmCode) {
      sessionStorage.setItem("CAME_FROM_CONFIRM_CODE", "false");
      this.$router.go(-2);
    } else {
      this.$router.go(-1);
    }
  }

  getOrderData() {
    if (!sessionStorage.getItem("ORDER_ID")) return;
    try {
      const req = new Request();
      req.body = {
        NRORG: sessionStorage.getItem("NRORG"),
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        ORDER_ID: sessionStorage.getItem("ORDER_ID"),
      };
      req.route = "getOrderData";
      req.callbackSuccess = (response: any) => {
        this.orderData = response.order;
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  selectStore() {
    const orders = JSON.parse(sessionStorage.getItem("ORDERS") || "[]");

    const order = orders.filter((order: any) =>
      order.id.toString().includes(sessionStorage.getItem("ORDER_ID"))
    );

    const storeId = order[0].storeId;

    sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(false));
    sessionStorage.removeItem("STRUCTURE_ID");
    sessionStorage.removeItem("CLICK_PRODUCT");
    if (sessionStorage.getItem("STORE")) {
      sessionStorage.removeItem("STORE");
      sessionStorage.removeItem("CURRENT_ORDER");
      sessionStorage.removeItem("ITEMS");
      sessionStorage.removeItem("DELIVERY_DATA");
    }
    if (!sessionStorage.getItem("CAME_FROM_RELEASE")) {
      sessionStorage.removeItem("DELIVER_AT");
      sessionStorage.removeItem("deliversToTable");
      sessionStorage.removeItem("deliversToBalcony");
      sessionStorage.removeItem("deliversToAddress");
      sessionStorage.removeItem("deliversToInternalLocation");
    }
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    sessionStorage.setItem("GO_TO_STORE", "true");
    if (
      sessionStorage.getItem("CURRENT_ORDER") &&
      storeId.toString() != sessionStorage.getItem("storeId")
    ) {
      sessionStorage.setItem("CURRENT_ORDER", "{}");
    }
    sessionStorage.setItem("storeId", storeId.toString());

    this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
      if (response) {
        sessionStorage.getItem("STORE")
          ? this.$router.push("Produtos")
          : this.goProducts();
      } else {
        sessionStorage.getItem("STORE")
          ? this.$router.push("ListaDeProdutos")
          : this.goProducts("ListaDeProdutos");
      }
    });
  }

  async getIfStoreHasAnySubmenu(storeId: number) {
    const request = new Request();
    request.route = `getIfStoreHasAnySubmenu?requestType=FilterData&STORE_ID=${storeId}`;
    request.showLoader = false;
    try {
      const response = await request.get();
      return response.ifStoreHasAnySubmenu.ifHasSubmenu;
    } catch (error) {
      console.error(error);
    }
  }

  goProducts(path = "Produtos") {
    sessionStorage.setItem("loadStore", JSON.stringify(true));
    this.$router.push(path);
  }
}
